<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="formProductoAlerta" (ngSubmit)="onSubmit()">
        <div class="grid form-group">
          <div class="col-3">
            <div class="div-form">
              <label>* {{ 'PRODUCTOSALERTA.LBL_ALERTA' | translate }}</label>
              <p-dropdown disableTab  id="idAlerta" name="idAlerta" [options]="listaAlertas" *ngIf="!idProductoAlerta"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                           formControlName="idAlerta"
              ></p-dropdown>
              <label *ngIf="idProductoAlerta" class="falso-combo-texto">{{productoAlerta.codigoAlerta}}</label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="alertaSubmitted && !f.idAlerta.valid">
                {{ 'PRODUCTOSALERTA.LBL_ALERTA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="div-form" style="margin-top: 25px;">
              <p-checkbox label="{{ 'PRODUCTOSALERTA.LBL_NOAPLICA' | translate}}" binary="true"
                          id="noAplica" [disabled]="visualizar"
                          formControlName="noAplica"></p-checkbox>
            </div>
          </div>

          <div class="col-2">
            <div class="div-form" style="margin-top: 25px;">
              <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                          id="indicadorHabilitado" [disabled]="visualizar"
                          formControlName="indicadorHabilitado"></p-checkbox>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons" *ngIf="!procesando">
          <div class="form-group col-12" *ngIf="!visualizar">
            <a (click)="cancelarEdicion()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
            <button icon="fa fa-floppy-o" label="{{tituloBoton | translate}}"
                    type="submit" pButton></button>
          </div>
        </div>
        <div class="grid" *ngIf="procesando">
          <div class="col-12 md:col-12 lg:col-12 text-center">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_PROCESANDO' | translate }}</span>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
